import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Connects to data-controller="camera-capture"
// Single-file twin of dropzone_controller — handles the mobile camera
// shortcut without pulling in the full Dropzone library for one input.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.element.addEventListener("change", this.#handleChange)
    this.element.dataset.cameraCaptureConnected = "true"
  }

  disconnect() {
    this.element.removeEventListener("change", this.#handleChange)
  }

  #handleChange = (event) => {
    const file = event.target.files[0]
    if (!file) return

    new DirectUpload(file, this.urlValue).create((error, blob) => {
      if (error) {
        console.error("DirectUpload failed", error)
        alert("Upload failed. Please try again.")
        return
      }
      this.#postSignedId(blob.signed_id)
    })
  }

  #postSignedId(signedId) {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = "/uploads"

    const csrf = document.createElement("input")
    csrf.type = "hidden"
    csrf.name = "authenticity_token"
    csrf.value = document.querySelector("meta[name='csrf-token']")?.content || ""
    form.appendChild(csrf)

    const fileInput = document.createElement("input")
    fileInput.type = "hidden"
    fileInput.name = "files[]"
    fileInput.value = signedId
    form.appendChild(fileInput)

    document.body.appendChild(form)
    // requestSubmit() (not submit()) so Turbo intercepts and the page
    // navigation goes through the Drive lifecycle.
    form.requestSubmit()
  }
}
